import { Link } from "react-router-dom"

export const ConditionalWrapper = ({ condition, children }) => {
  return condition ? <Link className="flex justify-start space-x-3 py-2 px-6 relative border-gray-200 border-b hover:bg-gray-50" to={condition}>{children}</Link> : <div className="flex justify-start space-x-3 py-2 px-6 relative border-gray-200 border-b hover:bg-gray-50" >{children}</div>
}